import {
  SET_SHOW_PUBLISH,
  SET_IS_CART,
  SET_ORDER_OBJ,
  SET_TALKBAO_INDEX,
  SET_IMPRINT_INDEX,
  SET_SHOW_UPDATENUM,
  SET_FOCUS_ADDREMARK,
  SET_USER_INFO,
  SET_BOOTHSTORE_DETAIL,
  SET_ORDER_KEYID,
  SET_templateLibraryId,
  SET_IGET_SALESNUM,
  SET_IGET_UPDATESALESNUM,
  SET_BACK_WAITORDER,
  SET_ADD_REMARKTEXT,
  SET_ADD_REMARKOBJ,
  SET_VIDEO_SHOW,
  SET_VIDEO_SRC,
  SET_Home_POP,
  SET_PASSWORD_STATUS,
  SET_STORE_ID,
  SET_NFC_READTXT,
  SET_NFC_WRITETXT,
  SET_WRITE_STATE,
  SET_USER_GEO,
  SET_LAST_CHIP_UID,
} from './mutations-type'
export default {
  updateTabActive(state, active) {
    state.active = active
  },
  setHintVisible(state, visible) {
    state.hintVisible = visible;
  },
  [SET_SHOW_PUBLISH](state, data) {
    state.showPublish = data;
  },
  [SET_IS_CART](state, data) {
    state.isCart = data;
  },
  [SET_ORDER_OBJ](state, data) {
    state.orderStateObj = data;
  },
  [SET_TALKBAO_INDEX](state, data) {
    state.talkbaoindex = data;
  },
  [SET_IMPRINT_INDEX](state, data) {
    state.imprintindex = data;
  },
  [SET_SHOW_UPDATENUM](state, data) {
    state.showUpdateNum = data;
  },
  [SET_FOCUS_ADDREMARK](state, data) {
    state.focusAddRemark = data;
  },
  //用户id
  [SET_USER_INFO](state, data) {
    localStorage.setItem('id', JSON.stringify(data))
    state.id = data;
  },
  //展台店铺详情
  [SET_BOOTHSTORE_DETAIL](state, data) {
    state.boothStoreDetail = data;
  },
  //订单主键ID
  [SET_ORDER_KEYID](state, data) {
    state.orderKeyId = data;
  },
  // 选择模板id
  [SET_templateLibraryId](state, data) {
    state.templateLibraryId = data;
  },
  // 我抢到的弹出框文本
  [SET_IGET_SALESNUM](state, data) {
    state.iGetSalesNum = data;
  },
  [SET_IGET_UPDATESALESNUM](state, data) {
    state.iGetUpdateSalesNum = data;
  },
  [SET_BACK_WAITORDER](state, data) {
    state.backWaitOrder = data;
  },
  [SET_ADD_REMARKTEXT](state, data) {
    state.addRemarkText = data;
  },
  [SET_ADD_REMARKOBJ](state, data) {
    state.addRemarkObj = data;
  },
  [SET_VIDEO_SHOW](state, data) {
    state.videoShow = data;
  },
  [SET_VIDEO_SRC](state, data) {
    state.videoSrc = data;
  },
  [SET_Home_POP](state, data) {
    state.homePop = data;
  },
  [SET_PASSWORD_STATUS](state, data) {
    state.passwordStatus = data
  },
  // 店铺id
  [SET_STORE_ID](state, data) {
    state.storeId = data
  },
  //nfc
  setNfcReadTxt(state, data) {
    state.nfcReadTxt = data
  },
  //setNfcWriteTxt
  setNfcWriteTxt(state, data) {
    state.nfcWriteTxt = data
  },
  [SET_NFC_READTXT](state, data) {
    state.nfcReadTxt = data
  },
  [SET_NFC_WRITETXT](state, data) {
    state.nfcWriteTxt = data
  },
  [SET_WRITE_STATE](state, data) {
    state.isWriteState = data
  },
  setUserGeo(state, data) {
    state.userGeo = data
  },
  [SET_USER_GEO](state, data) {
    state.userGeo = data
  },
  setLastChipUid(state, data) {
    state.lastChipUid = data
  },

  [SET_LAST_CHIP_UID](state, data) {
    state.lastChipUid = data
  }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js